import { render, staticRenderFns } from "./CertificateStatus.vue?vue&type=template&id=b888c082&scoped=true&"
import script from "./CertificateStatus.vue?vue&type=script&lang=js&"
export * from "./CertificateStatus.vue?vue&type=script&lang=js&"
import style0 from "./CertificateStatus.vue?vue&type=style&index=0&id=b888c082&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b888c082",
  null
  
)

export default component.exports